import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { cn } from "../../lib/utils";

export const TooltipProvider = TooltipPrimitive.Provider;
export const Tooltip = TooltipPrimitive.Root;
export const TooltipTrigger = TooltipPrimitive.Trigger;

export function TooltipContent({ className, sideOffset = 6, ...props }) {
  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        sideOffset={sideOffset}
        className={cn(
          "z-50 rounded-md bg-[hsl(var(--bg-elev-2))] border border-[hsl(var(--border))] px-2.5 py-1 text-xs text-[hsl(var(--fg))] shadow-lg",
          className
        )}
        {...props}
      />
    </TooltipPrimitive.Portal>
  );
}
